import { Article } from '@web/newsfeed/Article/Article';
import { useGetArticles } from '@web/newsfeed/hooks/useGetArticles';
import { LoadMoreButton } from '@web/newsfeed/LoadMoreButton/LoadMoreButton';

import { ArticleListWrapper } from './articleList.styles';

type Props = {
  pageId: ID;
};

export const ArticleList = ({ pageId }: Props) => {
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading } = useGetArticles({
    pageId,
  });
  const isLoadingArticles = isLoading || isFetchingNextPage;
  const articles = data?.pages.flat();

  if (!articles?.length && !isLoadingArticles) {
    return null;
  }

  return (
    <ArticleListWrapper>
      {articles?.map((article) => (
        <Article key={article.id} article={article} />
      ))}
      <LoadMoreButton
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
        fetchNextPage={fetchNextPage}
      />
    </ArticleListWrapper>
  );
};
